import styles from './index.module.scss';
import { mergeClasses } from 'util/commons';
import { IconClear } from 'components/atoms/icons/IconClear';

interface NumberPadProps {
  onValueChange: (value: number | string) => void;
  disabled?: boolean;
}

export const DELETE_KEY = '#';
export const DECIMAL_POINT = '.';
export const INITIAL_VALUE = '0';

export const NumberPad = ({ onValueChange, disabled }: NumberPadProps) => {
  const Button = ({
    className,
    value,
    label,
  }: {
    value: number | string;
    className?: string;
    label?: React.ReactNode;
  }) => (
    <div
      className={mergeClasses(styles.button, className)}
      onClick={() => onValueChange(value)}
    >
      {label || value}
    </div>
  );

  return (
    <div
      className={mergeClasses(styles.numberPad, {
        [styles.disabled]: disabled,
      })}
    >
      {Array.from({ length: 9 }).map((_, i) => (
        <Button key={i} value={i + 1} />
      ))}
      <Button value={DECIMAL_POINT} />
      <Button value={0} />
      <Button
        value={DELETE_KEY}
        className={styles.deleteButton}
        label={
          <div className={styles.buttonLabel}>
            <IconClear size={24} />
          </div>
        }
      />
    </div>
  );
};
